__turbopack_context__.v({
  "className": "marcellus_cc0a42f2-module__7hGdqq__className",
});
